
import services from './ServiceMetadata';

// Vehicle Type Name comes from the Fare Estimate API (Bcc.Api.Model.ViewModel.VehicleType enum).
const byVehicleTypeName = (vehicleTypeName: string) => {

    let name = vehicleTypeName.toLowerCase();

    if (name === "sedan") return services.sedan;
    if (name === "wagon") return services.wagon;
    if (name === "maxi") return services.maxi;
    if (name === "silverservice") return services.silver;
    if (name === "wheelchair") return services.wheelchair;
    if (name === "limo") return services.limo;

    return undefined;
};

// Condition ID will come back from the Booking Status API (V1)
const byConditionId = (rawConditionId : number | string | null | undefined) => {
    
    if (!rawConditionId) return services.any;
    const conditionId = Number(rawConditionId);
    if (conditionId === 0) return services.any;
    if (conditionId === 3) return services.silver;
    if (conditionId === 6) return services.parcel;
    if (conditionId === 11) return services.wagon;
    if (conditionId === 12) return services.sedan;
    if (conditionId >= 13 && conditionId <= 15) return services.wheelchair;
    if (conditionId >= 16 && conditionId <= 21) return services.maxi;
    if (conditionId === 26) return services.maxi;
    if (conditionId === 31) return services.limo;
    if (conditionId === 37) return services.taxi;
    if (conditionId >= 101 && conditionId <= 104) return services.maxi;
    return services.any;
};

// TaxiServiceId will come back from GetServiceOfferings API (V2 / BookingApiV2)
const byTaxiServiceId = (taxiServiceId: number) => {
    if (taxiServiceId === 1) return services.any;
    if (taxiServiceId === 2) return services.sedan;
    if (taxiServiceId === 3) return services.wagon;
    if (taxiServiceId === 4) return services.silver;
    if (taxiServiceId === 5) return services.maxi;
    if (taxiServiceId === 6) return services.limo;
    if (taxiServiceId === 7) return services.anySA;
    if (taxiServiceId === 9) return services.silverexec;
    if (taxiServiceId === 10) return services.silverexecxl;
    if (taxiServiceId === 11) return services.wheelchair;
    if (taxiServiceId === 12) return services.parcel;
    
    return services.any;  // Unknown TaxiServiceId
};

/**
 * This method accepts the input parameter from the url query string on the booking page e.g. service=parcel
 */
const GetServiceByUrlRef = (serviceName: string) => {

    let name = serviceName.toLowerCase();

    if (name === "silverservice") return services.silver;
    if (name === "sedan") return services.sedan;
    if (name === "wheelchair") return services.wheelchair;
    if (name === "maxitaxi") return services.maxi;
    if (name === "parcel") return services.parcel;

    // By default "Next Available" will be selected, if no match found
    return services.any;

}

export { byVehicleTypeName, byConditionId, byTaxiServiceId, GetServiceByUrlRef };
